import React from "react";
var __jsx = React.createElement;
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import { Controller, useFormContext } from 'react-hook-form';

var SwitchInput = function SwitchInput(_ref) {
  var name = _ref.name,
      label = _ref.label,
      defaultValue = _ref.defaultValue;

  var _useFormContext = useFormContext(),
      control = _useFormContext.control;

  return __jsx(Controller, {
    control: control,
    name: name,
    defaultValue: defaultValue !== null && defaultValue !== void 0 ? defaultValue : false,
    render: function render(_ref2) {
      var _ref2$field = _ref2.field,
          _onChange = _ref2$field.onChange,
          value = _ref2$field.value;
      return __jsx(FormControlLabel, {
        control: __jsx(Switch, {
          id: "form-field-".concat(name),
          onChange: function onChange(e) {
            return _onChange(e.target.checked);
          },
          checked: value,
          name: name
        }),
        label: label
      });
    }
  });
};

export default SwitchInput;